interface Props {
  title: string;
  description?: string;
  className?: string;
  children: React.ReactNode;
  options?: React.ReactNode;
}

export default function WidgetWrapper({
  title,
  description,
  children,
  className = "",
  options,
}: Props) {
  return (
    <div className="my-2 p-2 rounded btn-oauth mr-3 mr-md-0">
      <div className="d-flex justify-content-between align-items-center mx-3 py-1 mb-2">
        <div>
          <h2 className="mb-0 text-dark">{title}</h2>
          {description && <small>{description}</small>}
        </div>
        {options && options}
      </div>
      <div className={className} style={{ maxHeight: 650, overflow: "auto" }}>
        {children}
      </div>
    </div>
  );
}
